<template>
  <StaticModal
    variant-class-name="auto-email-settings-save-modal"
    title="Save automation settings?"
    @close="emit('close')"
  >
    <div class="mode-save-modal-ui">
      <div class="mode-save-modal-ui__body">
        <img :src="infoDanger" alt="" class="mode-save-modal-ui__icon" />
        <p class="mode-save-modal-ui__message">
          If you save automation mode settings, you cannot change automation mode again until the next
          day.
        </p>
      </div>
      <div class="mode-save-modal-ui__actions">
        <VBtn flat class="auto-email-template-close" @click="emit('close')">Close</VBtn>
        <VBtn :loading="isSaving" :disabled="isLoading" @click="emit('confirm')">
          Change anyway
        </VBtn>
      </div>
    </div>
  </StaticModal>
</template>

<script lang="ts" setup>
  // Components
  import StaticModal from '~/misc/modal/StaticModal.vue';
  import VBtn from '~/misc/v-btn';

  // Assets
  import infoDanger from '~/assets/images/icons/info-danger.svg';

  defineProps({
    isLoading: {
      type: Boolean,
      default: false,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits<{
    (e: 'close'): void;
    (e: 'confirm'): void;
  }>();
</script>
